import { defineAction } from '~/prix'
import { z } from 'zod'
import { machineServiceDocumentStatus } from '../machineServiceDocumentObject'
import machineServiceDocumentConfirmAction from './machineServiceDocumentConfirm.action.json' with { type: 'json' }

const machineServiceDocumentConfirmDefinition = defineAction({
  ...machineServiceDocumentConfirmAction,

  input: z.object({
    id: z.string().uuid(),
    status: machineServiceDocumentStatus,
  }),
  output: z.object({}),
})

export default machineServiceDocumentConfirmDefinition
